import React from 'react'
import img2035 from '../components/images/iwalmart.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2035} alt='walmart' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Walmart International Account Management
                    </h2>
                    <p>Maximize your global presence on Walmart with our specialized account management services designed to elevate your brand and boost your sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b> Enhance visibility with expertly crafted product listings. </li>
                <li><b>•	Advertising Campaign:</b>Maximize reach and ROI through targeted ad strategies. </li>
                <li><b>•	Promotion:</b> Maximize reach and ROI through targeted ad strategies.</li>
                <li><b>•	Brand Registry:</b>Secure your brand’s identity and increase customer trust.</li>
                <li><b>•	Brand Approval:</b> Navigate the approval process for new brands with ease. </li>
                <li><b>•	Account Health:</b> Maintain a healthy seller account to avoid penalties and issues. </li>
                <li><b>•	Order Processing:</b> Streamline order management for faster fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate and timely payment processing. </li>
                <li><b>•	Keyword Optimization:</b> Improve search rankings with strategic keyword use. </li>
                <li><b>•	Safety Compliance:</b> Manage product safety and compliance with Walmart standards. </li>
                <li><b>•	Basic Training:</b>Equip your team with essential Walmart knowledge and best practices. </li>
                <li><b>•	Sales Boost:</b>Implement strategies to significantly increase sales and expand your reach.</li>
            </ul>
        </>
    )
}

export default events